// import ServiceSubServiceSelectMenu from "@/app/components/ui/SelectMenus/ServiceSubServiceSelectMenu";
import { useArrayConstants } from "@/app/hooks/useArrayConstants";
import { EnvelopeIcon, UserPlusIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import React from "react";
// import { useForm } from "react-hook-form";
import InputWithAddOn from "@/app/components/ui/Inputs/InputWithAddOn";
import InputWithEndIcon from "@/app/components/ui/Inputs/InputWithEndIcon";
import InputWithStartIcon from "@/app/components/ui/Inputs/InputWithStartIcon";
import { MdAddchart, MdOutlineScreenSearchDesktop } from "react-icons/md";
import { PiDog, PiUserListLight } from "react-icons/pi";
import { SiStackoverflow } from "react-icons/si";
import { Link } from "react-router-dom";
import { IDashboardComponentProps } from "./interface";

const DASHBOARD_ICONS = {
  add_customer: <UserPlusIcon className="w-4 h-4" />,
  pwl: <PiUserListLight />,
  cao: <SiStackoverflow />,
  cab: <MdAddchart />,
  sfc: <MdOutlineScreenSearchDesktop />,
  sfp: <PiDog />,
};

const DashboarComponent: React.FC<IDashboardComponentProps> = () => {
  const { dashboardCardItems: items } = useArrayConstants();

  return (
    <div className="pl-10 mt-8">
      <ul role="list" className="mt-6 grid grid-cols-1 gap-6   py-6 sm:grid-cols-2">
        {items.map((item, itemIdx) => (
          <li key={itemIdx} className="flow-root">
            <Link
              to={item.url}
              className="relative -m-2 flex items-center space-x-4 rounded-xl p-2 focus-within:ring-2 focus-within:ring-indigo-500 hover:bg-gray-50"
            >
              <div
                className={clsx(
                  item.background,
                  "flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-lg text-white text-lg",
                )}
              >
                {DASHBOARD_ICONS[item?.id]}
              </div>
              <div>
                <h3 className="text-sm font-medium text-gray-900">
                  <a href="#" className="focus:outline-none">
                    <span className="absolute inset-0" aria-hidden="true" />
                    <span>{item.title}</span>
                    <span aria-hidden="true"> &rarr;</span>
                  </a>
                </h3>
                <p className="mt-1 text-sm text-gray-500">{item.description}</p>
              </div>
            </Link>
          </li>
        ))}
      </ul>
      <div className="mt-10">
        <InputWithStartIcon icon={<EnvelopeIcon className="w-4 h-4" />} />
        <InputWithEndIcon icon={<EnvelopeIcon className="w-4 h-4" />} />
        <InputWithAddOn addon={"https://"} />
      </div>
    </div>
  );
};

export default DashboarComponent;
